import React, { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Table from '../../Components/Script/Table';
import { getCreditCards, UpdateCreditCard,addCreditCard } from '../../Services/creditCard';

function AllCreditCardAdmin() {
    const [creditCards, setCreditCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [banknamecreditcard, setbanknamecreditcard] = useState("");
    const [urllinkcreditcard, seturllinkcreditcard] = useState("");
    // const [imagecreditcard, setimagecreditcard] = useState(null);
    const [imagecreditcard, setimagecreditcard] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [remarks, setremarks] = useState("");
    const [pincodeList, setpincodeList] = useState("");
    

    useEffect(() => {
        fetchCreditCards();
    }, []);

    const fetchCreditCards = async () => {
        try {
            const data = await getCreditCards();
            const sortedData = data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            setCreditCards(sortedData);
        } catch (error) {
            console.error('Error fetching credit card applications:', error);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setimagecreditcard(file);
            setImagePreview(URL.createObjectURL(file)); // Preview Image
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!banknamecreditcard || !urllinkcreditcard || !imagecreditcard || !remarks || !pincodeList) {
            alert("Please fill all required fields.");
            return;
        }

        const formData = new FormData();
        formData.append("banknamecreditcard", banknamecreditcard);
        formData.append("urllinkcreditcard", urllinkcreditcard);
        formData.append("imagecreditcard", imagecreditcard);
        formData.append("remarks", remarks);
        formData.append("pincodeList", pincodeList);

        try {
            await addCreditCard(formData);
            fetchCreditCards(); // Refresh data

            // Reset Form
            setbanknamecreditcard("");
            seturllinkcreditcard("");
            setimagecreditcard(null);
            setImagePreview(null);
            setremarks("");
            setpincodeList("");
        } catch (error) {
            console.error("Error adding credit card:", error);
            alert("Failed to add credit card.");
        }
    };

    const openModal = (card) => {
        setSelectedCard(card);
        setbanknamecreditcard(card.banknamecreditcard);
        seturllinkcreditcard(card.urllinkcreditcard);
        //setimagecreditcard(null); // Keep image unchanged unless updated
        setremarks(card.remarks);
        setpincodeList(card.pincodeList);

        const modal = new window.bootstrap.Modal(document.getElementById('creditcard-modal'));
        modal.show();
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!selectedCard) {
            alert("No credit card selected.");
            return;
        }

        if (!banknamecreditcard || !urllinkcreditcard || !remarks || !pincodeList) {
            alert("Please fill all required fields.");
            return;
        }

        const updateData = {
            id: selectedCard.id, // Ensure ID is sent correctly
            banknamecreditcard,
            urllinkcreditcard,
            remarks,
            pincodeList
        };

        try {
            await UpdateCreditCard(selectedCard.id, updateData);
            fetchCreditCards(); // Refresh the data

            // Close modal and reset form
            const modalElement = document.getElementById('creditcard-modal');
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) modalInstance.hide();

            setSelectedCard(null);
            setbanknamecreditcard("");
            seturllinkcreditcard("");
            setremarks("");
            setpincodeList("");
        } catch (error) {
            console.error("Error updating credit card:", error);
            alert("Failed to update credit card.");
        }
    };


    return (
        <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">All Credit Cards</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">All Credit Cards</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputBankName" className="form-label">Bank Name</label>
                                                        <input type="text" className="form-control" id="inputBankName" value={banknamecreditcard} onChange={(e) => setbanknamecreditcard(e.target.value)} placeholder="Bank Name" />
                                                    </div>
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputCreditCardLink" className="form-label">Credit Card Link</label>
                                                        <input type="text" className="form-control" id="inputCreditCardLink" value={urllinkcreditcard} onChange={(e) => seturllinkcreditcard(e.target.value)} placeholder="Credit Card Link" />
                                                    </div>
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputImage" className="form-label">Image</label>
                                                        <input type="file" className="form-control" id="inputImage" onChange={handleImageChange} />
                                                    </div>
                                                </div>
                                                
                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputRemarks" className="form-label">Remarks</label>
                                                        <textarea type="text" className="form-control" id="inputRemarks" value={remarks} onChange={(e) => setremarks(e.target.value)} placeholder="Remarks" />
                                                    </div>
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputPincodeListLink" className="form-label">Pincode List Link</label>
                                                        <input type="text" className="form-control" id="inputPincodeListLink" value={pincodeList} onChange={(e) => setpincodeList(e.target.value)} placeholder="Pincode List Link" />
                                                    </div>
                                                    {imagePreview && (
                                                    <div className="mb-3 col-md-4">
                                                        <label className="form-label">Image Preview</label>
                                                        <img src={imagePreview} alt="Preview" width="100" />
                                                    </div>
                                                )}
                                                </div>
                                                <button type="submit" className="btn btn-primary">Submit</button>
                                            </form>
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="fixed-columns-preview">

                                                    <div className="table-responsive">
                                                        <table id="fixed-columns-datatable" className="table table-striped table-bordered table-hover nowrap row-border order-column w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th>Bank Name</th>
                                                                    <th>Apply Link</th>
                                                                    <th>Image</th>
                                                                    <th>Remarks</th>
                                                                    <th>Pincode List</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {creditCards.length > 0 ? (
                                                                    creditCards.map((card) => (
                                                                        <tr key={card.id}>
                                                                            <td>{card.banknamecreditcard}</td>
                                                                            <td><a href={card.urllinkcreditcard} alt="Link" target="_blank" rel="noreferrer">Apply Link</a></td>
                                                                            <td><img src={`https://api.mysfs24.com/${card.imagecreditcard.replace('../', '')}`} alt="Credit Card" height="100px"></img></td>
                                                                            <td>{card.remarks}</td>
                                                                            <td><a href={card.pincodeList} alt="Link" target="_blank" rel="noreferrer">Pincode List Link</a></td>
                                                                            <td className="table-action">
                                                                                <i className="mdi mdi-pencil action-icon" onClick={() => openModal(card)} style={{ cursor: "pointer" }}></i>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> {/* end preview*/}
                                            </div> {/* end tab-content*/}
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}
                            {/* Modal */}
                            <div id="creditcard-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <div className="text-center mt-2 mb-4">
                                                {selectedCard && (
                                                    <>
                                                        <img src={selectedCard.imagecreditcard} alt="" height={50} />
                                                        <h5 className="mt-2">{selectedCard.banknamecreditcard.toUpperCase()}</h5>
                                                    </>
                                                )}
                                            </div>
                                            <form onSubmit={handleUpdateSubmit}>
                                                {/* CS Id Field */}
                                                <div className="mb-3">
                                                    <label className="form-label">Bank Name</label>
                                                    <input className="form-control" type="text" value={banknamecreditcard} onChange={(e) => setbanknamecreditcard(e.target.value)} />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Apply Link</label>
                                                    <input className="form-control" type="text" value={urllinkcreditcard} onChange={(e) => seturllinkcreditcard(e.target.value)} />
                                                </div>

                                                {/* Screenshot Upload */}
                                                {/* <div className="mb-3">
                                                    <label className="form-label">Image</label>
                                                    <input className="form-control" type="file" onChange={(e) => setimagecreditcard(e.target.files[0])} />
                                                </div> */}
                                                <div className="mb-3">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea className="form-control" type="text" value={remarks} onChange={(e) => setremarks(e.target.value)} />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Pincode List</label>
                                                    <input className="form-control" type="text" value={pincodeList} onChange={(e) => setpincodeList(e.target.value)} />
                                                </div>
                                                <div className="d-grid">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </div>
    )
}

export default AllCreditCardAdmin
